// extracted by mini-css-extract-plugin
export default {"lapUnassignedList":"lapUnasignedList_lapUnassignedList__ROrdi","lapUnassignedList__item":"lapUnasignedList_lapUnassignedList__item__2muGk"};